/**
 * Lightweight logger controlled by the `DEBUG_LOGGING` env var.
 *
 * - debug / info   → only printed when DEBUG_LOGGING=true
 * - warn / error   → always printed
 *
 * `vite.config.ts` shims `DEBUG_LOGGING` into `import.meta.env.VITE_DEBUG_LOGGING`,
 * so the same `.env` key works for the backend and the browser bundle.
 *
 * Usage:
 *   import { logger } from "@/lib/logger";
 *   logger.debug("[auth]", "login attempt", { email });
 */

function isEnabled(): boolean {
  return import.meta.env.VITE_DEBUG_LOGGING === "true";
}

export const logger = {
  debug: (...args: unknown[]): void => {
    if (isEnabled()) {
      console.debug(...args);
    }
  },
  info: (...args: unknown[]): void => {
    if (isEnabled()) {
      console.info(...args);
    }
  },
  warn: (...args: unknown[]): void => {
    console.warn(...args);
  },
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
};
